var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',{staticStyle:{"background":"#eee"},attrs:{"flat":""}},[(_vm.responsive)?_c('v-toolbar-side-icon',{staticClass:"default v-btn--simple",on:{"click":function($event){$event.stopPropagation();return _vm.onClickBtn.apply(null, arguments)}}}):_vm._e(),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }